import FlightLandIcon from "@mui/icons-material/FlightLand";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import { Stack, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import { TripWithTenant } from "../types";
import { formatDepartureDate } from "../utils/dateHelpers";

interface TripListDisplayProps {
  trips: TripWithTenant[];
  showTailNumber?: boolean;
  compact?: boolean;
}

export const TripListDisplay: React.FC<TripListDisplayProps> = ({
  trips,
  showTailNumber = false,
  compact = false,
}) => {
  const { t } = useTranslation();

  if (trips.length === 0) {
    return (
      <Typography variant="caption" color="text.secondary">
        {t("components.tripListDisplay.noTripsFound")}
      </Typography>
    );
  }

  return (
    <Stack spacing={compact ? 0.5 : 1}>
      {trips.map((trip) => (
        <Stack key={trip.trip_id} spacing={0.25}>
          {showTailNumber && (
            <Typography variant="caption" fontWeight={500}>
              {trip.tail_number} - {trip.owner_manager || t("components.tripListDisplay.noOwner")}
            </Typography>
          )}
          <Stack direction="row" spacing={1} alignItems="center">
            <FlightLandIcon sx={{ fontSize: 12, color: "text.secondary" }} />
            <Typography variant="caption">
              {format(parseISO(trip.arrival_date), "MMM d, HH:mm")}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              -
            </Typography>
            <FlightTakeoffIcon sx={{ fontSize: 12, color: "text.secondary" }} />
            <Typography variant="caption">
              {formatDepartureDate(trip.departure_date)}
            </Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};